export default "__VITE_ASSET__DtqXuEO5__"